import React from 'react'

const Export: React.FunctionComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="345"
    height="272"
    viewBox="0 0 345 272"
  >
    <defs>
      <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#A7A7EE" stopOpacity="0" />
        <stop offset="100%" stopColor="#4C55A0" stopOpacity=".2" />
      </linearGradient>
      <path
        id="a"
        d="M58.565 216.395c3.428 1.648 9.931 10.761 7.676 15.962-2.491 5.744-12.574 2.37-15.007-1.249-2.433-3.62-1.143-13.336-1.204-15.126 2.283 1.38 6.13 2.904 8.535.413z"
      />
      <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#A7A7EE" stopOpacity="0" />
        <stop offset="100%" stopColor="#4C55A0" stopOpacity=".2" />
      </linearGradient>
      <path
        id="c"
        d="M88.542 216.395c3.427 1.648 12.927 7.765 10.672 12.967-2.491 5.743-14.073 2.37-16.506-1.25s-4.139-10.34-4.2-12.13c2.283 1.38 7.629 2.904 10.034.413z"
      />
      <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#403F9F" stopOpacity="0" />
        <stop offset="100%" stopOpacity=".2" />
      </linearGradient>
      <path
        id="e"
        d="M47.345.899C28.165 5.684 28.008 18.94 16.78 30.555 5.53 42.095-8.337 54.704 6.293 66.502c11.594 8.983-1.428 25.348 19.777 40.141 21.421 14.97 82.104-13.396 82.104-40.14 0-27.036-30.794-23.69-27.568-39.543C83.743 11.125 66.818-3.877 47.345.9z"
      />
      <linearGradient id="g" x1="0%" y1="3.772%" y2="96.228%">
        <stop offset="0%" stopOpacity=".3" />
        <stop offset="100%" stopColor="#1F1845" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="j" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#403F9F" stopOpacity="0" />
        <stop offset="100%" stopOpacity=".2" />
      </linearGradient>
      <path
        id="i"
        d="M83.003 114.432c13.178 14.388 9.098 90.658 8.69 98.854-.075 7.812-12.679 5.811-14.383 3.295-1.473-2.912-6.385-73.704-8.09-73.691-1.623-.013-5.045 69.218-6.593 73.691-2.017 4.078-12 3.091-13.484 0-2.087-3.487-12.167-79.633 2.397-101.55 1.423-2.357 29.271-2.956 31.463-.6z"
      />
      <linearGradient id="l" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#A7A7EE" stopOpacity="0" />
        <stop offset="100%" stopColor="#4C55A0" stopOpacity=".2" />
      </linearGradient>
      <linearGradient id="m" x1="33.785%" x2="70.761%" y1="45.085%" y2="50%">
        <stop offset="0%" stopColor="#464D89" stopOpacity=".6" />
        <stop offset="100%" stopColor="#A7A7EE" stopOpacity="0" />
      </linearGradient>
      <path
        id="k"
        d="M70.718 62.608c13.018 0 24.278 14.66 26.07 29.956 1.804 15.177 4.366 19.613-1.798 18.872-7.986-1.768-37.327-48.828-24.272-48.828z"
      />
      <linearGradient id="o" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#A7A7EE" stopOpacity="0" />
        <stop offset="100%" stopColor="#4C55A0" stopOpacity=".2" />
      </linearGradient>
      <path
        id="n"
        d="M0 10.485c.143 9.926.85 38.704 8.99 42.237 8.3 3.328 29.151 1.798 33.26 0 3.922-1.903 7.39-45.455-5.093-50.326C24.994-2.349.143.443 0 10.485z"
      />
      <linearGradient id="p" x1="0%" x2="163.223%" y1="6.42%" y2="177.059%">
        <stop offset="0%" stopColor="#464D89" stopOpacity=".3" />
        <stop offset="100%" stopColor="#A7A7EE" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="s" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#A7A7EE" stopOpacity="0" />
        <stop offset="100%" stopColor="#4C55A0" stopOpacity=".2" />
      </linearGradient>
      <path
        id="r"
        d="M54.079 98.839c3.968-1.597 8.181-3.03 10.346-3.879 2.57-.617 4.963 4.145 3.296 5.692-5.296 5.252-9.73 15.577-16.18 15.577-2.158 0-4.086-1.178-5.448-2.892-2.443-2.74-4.275-7.6-5.34-14.482-2.304-14.508-3.678-28.914 4.195-32.353 7.947-3.186 8.272 17.3 8.39 26.661-.024 1.873.286 3.79.74 5.676z"
      />
      <linearGradient id="u" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#A7A7EE" stopOpacity="0" />
        <stop offset="100%" stopColor="#4C55A0" stopOpacity=".2" />
      </linearGradient>
      <path
        id="t"
        d="M94.99 111.436c5.458.935 8.69-4.381 8.69-19.77 0-9.418-6.647-7.168-9.29-2.397-3.913 7.064-5.01 20.968.6 22.167z"
      />
      <linearGradient id="w" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FFC62C" stopOpacity="0" />
        <stop offset="100%" stopColor="#FF6663" stopOpacity=".1" />
      </linearGradient>
      <path
        id="v"
        d="M95.29 87.172c5.34.003 8.137.003 8.39 0 .357.004 7.661-.637 15.881-3.894 5.195-1.885 5.854.909 4.495 3.894-.993 1.676-2.61 3.454-4.495 4.493-5.055 2.24-15.767-3.162-15.882 0 .115 4.483-9.072.903-9.289-2.396-.006-.583.404-1.354.9-2.097z"
      />
      <linearGradient id="y" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FFC62C" stopOpacity="0" />
        <stop offset="100%" stopColor="#FF6663" stopOpacity=".1" />
      </linearGradient>
      <path
        id="x"
        d="M64.425 94.96c2.04-.927 4.364-2.434 4.795-3.295 1.813-3.328-.724-8.437 1.498-9.286 1.948-1.288 3.25 2.887 2.697 5.991-.739 2.733 3.988 2.17 7.191.6 3.458-1.886 13.691 3.629 8.39 6.889-5.26 3.007-14.387 1.482-17.679 1.498-.488-.01-1.687 1.088-3.596 3.295-4.08-2.898-5.178-4.796-3.296-5.692z"
      />
      <linearGradient id="A" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FFC62C" stopOpacity="0" />
        <stop offset="100%" stopColor="#FF6663" stopOpacity=".1" />
      </linearGradient>
      <path id="z" d="M0 0h12.885v10.632a6.443 6.443 0 0 1-12.885 0V0z" />
      <linearGradient id="B" x1="100%" x2="0%" y1="24.029%" y2="75.971%">
        <stop offset="0%" stopOpacity=".2" />
        <stop offset="100%" stopColor="#FFC42C" stopOpacity="0" />
      </linearGradient>
      <linearGradient id="D" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FFC62C" stopOpacity="0" />
        <stop offset="100%" stopColor="#FF6663" stopOpacity=".1" />
      </linearGradient>
      <path
        id="C"
        d="M4.885 23.902c-1.1-.089-2.169-1.165-2.188-3.832C2.723 16.371 0 15.225 0 12.881c0-2.474 2.48-3.483 3.814-1.899l.081-.198c1.21-2.616 3.3-1.658 12.286-4.194C25.247 4.31 28.777-2.35 36.258.9c.04 1.372-.009 5.935 0 7.489-.009 1.422 1.798 3.29 1.798 9.885 0 6.547-6.94 15.577-14.683 15.577-5.785 0-15.084-3.314-18.488-9.948z"
      />
      <linearGradient id="F" x1="100%" x2="0%" y1="43.223%" y2="56.777%">
        <stop offset="0%" stopOpacity=".1" />
        <stop offset="100%" stopColor="#FFC42C" stopOpacity="0" />
      </linearGradient>
      <path
        id="E"
        d="M3.83 10.941l.065-.157c1.21-2.616 3.3-1.658 12.286-4.194C25.247 4.31 28.777-2.35 36.258.9c.022.753.017 2.466.01 4.115-2.905-.386-6.005.473-9.3 2.578-9.987 6.382-18.839 4.122-23.137 3.349z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#EBEEF2"
        d="M0 156.37c0-44.02 22.287-62.462 77.61-74.89C132.968 69.253 140.305 0 212.153 0 284.2 0 378.886 123.298 331.115 194.115c-47.754 70.886-180.397-25.813-223.84 6.29C63.748 232.356 0 200.268 0 156.37z"
      />
      <path
        fill="#F0F0F6"
        d="M120.286 259.376c4.352-17.581 43.483-27.817 70.398-27.817 26.967 0 45.66 18.236 21.41 30.282-24.11 12.05-95.809 15.067-91.808-2.465z"
      />
      <g transform="translate(102.746 26.062)">
        <use fill="#5E7CF3" xlinkHref="#a" />
        <use fill="url(#b)" xlinkHref="#a" />
      </g>
      <g transform="translate(102.746 26.062)">
        <use fill="#5E7CF3" xlinkHref="#c" />
        <use fill="url(#d)" xlinkHref="#c" />
      </g>
      <g transform="translate(102.746 26.062)">
        <mask id="h" fill="#fff">
          <use xlinkHref="#e" />
        </mask>
        <use fill="#222E60" xlinkHref="#e" />
        <use fill="url(#f)" xlinkHref="#e" />
        <path
          fill="url(#g)"
          d="M77.91 25.463c20.512 10.632 31.699 17.721 33.56 21.268 4.681 9.196 6.243 12.6 8.39 32.952 2.029 20.139-38.53 27.553-41.95 30.222-5.19 3.87-50.195 1.19-46.951-41.17 1.14-16.066 6.004-27.095 14.588-33.087l32.362-10.185z"
          mask="url(#h)"
        />
      </g>
      <g transform="translate(102.746 26.062)">
        <use fill="#232F61" xlinkHref="#i" />
        <use fill="url(#j)" xlinkHref="#i" />
      </g>
      <g transform="translate(102.746 26.062)">
        <use fill="#5C7BF5" xlinkHref="#k" />
        <use fill="url(#l)" xlinkHref="#k" />
        <use fill="url(#m)" xlinkHref="#k" />
      </g>
      <g transform="translate(143.498 87.77)">
        <mask id="q" fill="#fff">
          <use xlinkHref="#n" />
        </mask>
        <use fill="#597AF8" xlinkHref="#n" />
        <use fill="url(#o)" xlinkHref="#n" />
        <path
          fill="url(#p)"
          d="M12.585 55.419c-2.518 0-.285-33.488 0-33.85 5.79-.782 1.869 25.17 17.38 13.18.341-.082 18.46-3.774 17.68 0-.833 3.97-12.177 2.069-15.582 3.894-8.053 3.902-9.927 16.776-19.478 16.776z"
          mask="url(#q)"
        />
      </g>
      <g transform="translate(102.746 26.062)">
        <use fill="#5C7BF5" xlinkHref="#r" />
        <use fill="url(#s)" xlinkHref="#r" />
      </g>
      <g transform="translate(102.746 26.062)">
        <use fill="#5E7CF3" xlinkHref="#t" />
        <use fill="url(#u)" xlinkHref="#t" />
      </g>
      <g transform="translate(191.143 62.308)">
        <rect width="40.453" height="50.026" x=".899" y=".899" fill="#DEDEDE" rx=".9" />
        <rect width="40.453" height="50.026" fill="#FFF" rx=".9" />
      </g>
      <g fill="#D8D8D8">
        <path d="M196.836 72.793h17.08v2.696h-17.08zM196.836 81.181h26.67v2.696h-26.67zM196.836 86.573h22.174v2.696h-22.174zM196.836 91.965h22.174v2.696h-22.174z" />
      </g>
      <g transform="translate(102.746 26.062)">
        <use fill="#FFC62C" xlinkHref="#v" />
        <use fill="url(#w)" xlinkHref="#v" />
      </g>
      <g transform="translate(102.746 26.062)">
        <use fill="#FFC62C" xlinkHref="#x" />
        <use fill="url(#y)" xlinkHref="#x" />
      </g>
      <g transform="translate(160.878 78.185)">
        <use fill="#FFC62C" xlinkHref="#z" />
        <use fill="url(#A)" xlinkHref="#z" />
      </g>
      <path
        fill="url(#B)"
        d="M12.885 7.527c-1.857 1.097-3.896 1.76-5.993 1.76-2.006 0-4.434-.4-6.892-1.196V0h12.885v7.527z"
        transform="translate(160.878 78.185)"
      />
      <g transform="translate(144.397 50.626)">
        <use fill="#FFC62C" xlinkHref="#C" />
        <use fill="url(#D)" xlinkHref="#C" />
        <use fill="url(#F)" xlinkHref="#E" />
      </g>
    </g>
  </svg>
)

export default Export
